class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    this.searchPanel = this.querySelector('.search-modal');
    this.motionVersion = 0;
    this.isClosing = false;

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));
    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    if (this.isClosing || !this.isOpen()) this.open(event);
    else this.close();
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  canAnimateSearch() {
    return this.searchPanel && typeof this.searchPanel.animate === 'function' &&
      !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  open(event) {
    const wasOpen = this.isOpen();
    const from = wasOpen && this.searchPanel
      ? Number(window.getComputedStyle(this.searchPanel).opacity)
      : 0;
    this.motionVersion += 1;
    this.panelAnimation?.cancel();
    this.panelAnimation = null;
    this.isClosing = false;
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    this.detailsContainer.setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');
    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
    if (!this.canAnimateSearch()) return;
    const animation = this.searchPanel.animate(
      [{ opacity: from }, { opacity: 1 }],
      { duration: Math.max(1, 180 * (1 - from)), easing: 'cubic-bezier(0.16, 1, 0.3, 1)' }
    );
    this.panelAnimation = animation;
    animation.finished.then(() => {
      if (this.panelAnimation === animation) this.panelAnimation = null;
    }).catch(() => {});
  }

  close(focusToggle = true) {
    if (!this.isOpen() || this.isClosing) return;
    if (!this.canAnimateSearch()) {
      this.finishClose(focusToggle);
      return;
    }
    const from = Number(window.getComputedStyle(this.searchPanel).opacity);
    this.panelAnimation?.cancel();
    this.isClosing = true;
    const version = ++this.motionVersion;
    const animation = this.searchPanel.animate(
      [{ opacity: from }, { opacity: 0 }],
      { duration: Math.max(1, 140 * from), easing: 'cubic-bezier(0.16, 1, 0.3, 1)', fill: 'forwards' }
    );
    this.panelAnimation = animation;
    animation.finished.then(() => {
      if (version === this.motionVersion && this.isClosing) this.finishClose(focusToggle);
    }).catch(() => {});
  }

  finishClose(focusToggle) {
    this.detailsContainer.removeAttribute('open');
    this.panelAnimation?.cancel();
    this.panelAnimation = null;
    this.isClosing = false;
    this.motionVersion += 1;
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
  }
}

customElements.define('details-modal', DetailsModal);